export const menu = {
    PRODUCTS: {TITLE: "Products", URL: "/#/products?name=Orange_Juice&variant=15.2oz_bottle"},
    // BUY_NOW: {TITLE: "Buy Now", URL: "#",
    // VENDORS: [
    //     {TITLE:"Retailer FPO", URL:"#"},
    //     {TITLE:"Retailer FPO2", URL:"#"},
    // ]},
    LOCATOR: {TITLE: "Product Locator", URL: "https://contact.pepsico.com/dolejuice/product-locator"},
    SERVE_DOLE: {TITLE: "Serve Dole Juice", URL: "https://www.pepsicopartners.com/pepsico/en/USD/BEVERAGES/Juices-%26-Shakes/c/juicesShakes?q=%3Arelevance%3AdisplayCategory%3Atrue%3AlocationAvailibility%3Atrue%3Abrand%3Abrand_dole%3AdisplayCategory%3Atrue%3AlocationAvailibility%3Atrue%3AdisplayCategory%3Atrue%3AlocationAvailibility%3Atrue&productType=Product&text=&page=0"},
    CONTACT: {TITLE: "Contact", URL: "https://contact.pepsico.com/dolejuice"},
    JUICE_URL: {TITLE: "Dole Lemonade", URL: "https://dolelemonade.com/"},
}

export const menu_products = [
    {img: "orange-juice-menu@2x.png", bgUrl: "orange-juice-menu-bg.png"},
    {img: "tfp-menu@2x.png", bgUrl: "tfp-menu-bg.png"},
    {img: "apple-juice-menu@2x.png", bgUrl: "apple-juice-menu-bg.png"}
]

export const carousel_card = {
    LEARN_MORE: "Learn More",
}

export const ctas = {
    FIND_IT: "Find It",
    BUY_IT: "Buy It"
}

export const carousel_products = [
    { 
        NAME: "Dole Lemonade", 
        DESC: "Phasellus gravida ornare augue sed rhoncus. Mauris vitae lorem quam. Donec id volutpat ex. Sed hendrerit tincidunt rhoncus.",  
        IMG: "group-103@2x.png", 
        FIND_IT_URL: "", 
        BUY_IT_URL: ""
    },
    { 
        NAME: "Dole Strawberry Lemonade", 
        DESC: "Phasellus gravida ornare augue sed rhoncus. Mauris vitae lorem quam. Donec id volutpat ex. Sed hendrerit tincidunt rhoncus.",  
        IMG: "dole-lemonade-strawberry@2x.png", 
        FIND_IT_URL: "", 
        BUY_IT_URL: ""
    }
]

export const mixology = {
    BODY: "Phasellus gravida ornare augue sed rhoncus. Mauris vitae lorem quam. Donec id volutpat ex. Sed hendrerit tincidunt rhoncus.",
    BUTTON: "Check it out",
    LOAD_MORE: "LOAD MORE RECIPES",
    SORT: "Filter By",
    FILTERS: [
        "Most Recent",
        "Name",
        "Flavor"
    ],
    FLAVORS: [
        "Apple",
        "Orange",
        "Grapefruit",
        "Punch"
    ]
}

export const recipe =  {
    BACK: "BACK TO RECIPES",
    TOTAL_PREP: "Total Prep Time: ",
    INGREDIENTS: "Ingredients",
    DIRECTIONS: "Directions"
}

export const ageCheck = {
    DISCLAIMER: "This site is intended for those of legal drinking age. By visiting the Dole Mixology site, you affirm that you are of legal drinking age in the country where the site is being accessed."
}

export const Module = {
    mixology: {
        header: "mixology"
    }
}

export const siteSwap = {
    TITLE: "If you love Dole<sup>&reg;</sup> Juice,<br> try Dole<sup>&reg;</sup> Lemonade",
    BUTTON: {TITLE:"Visit<br>Dole Lemonade", URL:"https://dolelemonade.com/"}
}

export const footer = {
    PRIVACY:{TITLE: "Privacy Policy", URL: "https://policy.pepsico.com/privacy"},
    TERMS: {TITLE: "Terms & Conditions", URL: "https://policy.pepsico.com/terms"},
    ADS: {TITLE: "About our Ads", URL: "https://policy.pepsico.com/aboutads"},
    CONTACT: {TITLE: "Contact", URL: "https://contact.pepsico.com/dolejuice"}
}